import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Fixed } from 'layouts';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Switch,
  FormControlLabel,
  Tooltip,
  Radio,
  Checkbox,
  ListItemText,
  FormLabel,
  FormGroup,
  Card,
  Typography,
  TextField,
  OutlinedInput,
  Chip,
  Modal,
  InputAdornment,
  CircularProgress,
  Icon,
  Divider,
  DialogContentText,
  RadioGroup,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Menu,
} from '@mui/material';
import moment from 'moment';
import {
  Add,
  AddCircle,
  Close,
  CloudDownload,
  CopyAll,
  Delete,
  DeleteOutline,
  Description,
  Edit,
  EditOutlined,
  ExpandMore,
  Group,
  Link,
  Lock,
  Mic,
  MoreVert,
  Notes,
  Redo,
  Replay,
  Send,
  StopCircle,
} from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import getAllVideoDataPoints from 'redux/actions/Common/getAllVideoDataPoints';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import SkillTagInput from './components/skillTagInput';
import labelDataPoint from 'redux/actions/Common/labelDataPoint';
import addLabels from 'redux/actions/Common/addLabels';
import getLabels from 'redux/actions/Common/getLabels';
import getAllRagQueries from 'redux/actions/Common/getAllRagQueries';
import getMessageResponse from 'redux/actions/Common/getMessageResponse';
import getConversationById from 'redux/actions/Common/getConversationById';
import createNewConversation from 'redux/actions/Common/createNewConversation';

import RecordRTC, { RecordRTCPromisesHandler } from 'recordrtc';
import SpeechRecognition, {
  useSpeechRecognition,
} from 'react-speech-recognition';
import getDefaultPrompt from 'redux/actions/Common/getDefaultPrompt';
import uploadAudio from 'redux/actions/Common/uploadAudio';
import verifyAudioUpload from 'redux/actions/Common/verifyAudioUpload';
import getMergedConversation from 'redux/actions/Common/getMergedConversation';
import getUploadAudioUrlForConversation from 'redux/actions/Common/getUploadAudioUrlForConversation';
import deleteConversation from 'redux/actions/Common/deleteConversation';
import updateConversation from 'redux/actions/Common/updateConversation';
import getCreds from 'redux/actions/Common/getCreds';

import * as TranscribeClient from './components/transcribe';
import getGptRequestDataByMsgId from 'redux/actions/Common/getGptRequestDataByMsgId';
import getPineconeIndices from 'redux/actions/Common/getPineconeIndices';
import processRagQuery from 'redux/actions/Common/processRagQuery';
import deleteRagQuery from 'redux/actions/Common/deleteRagQuery';
import getUploadUrlForFile from 'redux/actions/Common/getUploadUrlForFile';
import confirmFileUpload from 'redux/actions/Common/confirmFileUpload';
import getUploadedFiles from 'redux/actions/Common/getUploadedFiles';
import deleteRagDocuments from 'redux/actions/Common/deleteRagDocuments';
import getDocumentNamespaces from 'redux/actions/Common/getDocumentNamespaces';
import AutoCompleteMUI from 'components/@2024/AutoCompleteMUI';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const defaultLabels = [
  'clarity',
  'pace',
  'fluency',
  'confidence',
  'enthusiasm',
  'delivery',
  'content',
];

const RagDocuments = () => {
  const theme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();
  const { pathname, state } = useLocation();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const isXs = useMediaQuery(theme.breakpoints.only('xs'), {
    defaultMatches: true,
  });
  const isSm = useMediaQuery(theme.breakpoints.only('sm'), {
    defaultMatches: true,
  });
  const chatsScrollview = useRef(null);

  const awsCreds = useSelector((state) => state.awsCreds);
  const [newConversationDialog, setNewConversationDialog] = useState(false);
  const {
    conversations,
    fetchingPagination,
    emptyList,
    fetching,
    lastSeen,
  } = useSelector((state) => state.allConversations);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [
    showValuePropFileUploadDialog,
    setShowValuePropFileUploadDialog,
  ] = useState(false);
  const inputFile = useRef(null);
  const [invalidFile, setInvalidFile] = useState(false);
  const [fileUploading, setFileUploading] = useState(false);

  const [
    showConfirmDeleteValuePropFile,
    setShowConfirmDeleteValuePropFile,
  ] = useState(null);
  const [deletingValuePropFile, setDeletingValuePropFile] = useState(false);

  const [valuePropFileTitleEditMode, setValuePropFileTitleEditMode] = useState(
    null,
  );

  const [valuePropFileTitle, setValuePropFileTitle] = useState('');
  const [updatingValuePropFileTitle, setUpdatingValuePropFileTitle] = useState(
    false,
  );

  const [valuePropFiles, setValuePropFiles] = useState([]);
  const [valuePropFileIds, setValuePropFileIds] = useState([]);
  const [valuePropEditMode, setValuePropEditMode] = useState(false);

  const [selectedRagQuery, setSelectedRagQuery] = useState(null);
  const [pineconeIndices, setPineconeIndices] = useState(null);
  const [ragIndexName, setRagIndexName] = useState(0);
  const [namespace, setNamespace] = useState('');

  const [documentNamespaces, setDocumentNamespaces] = useState([]);

  const onFileChange = (event) => {
    console.log(event.target.files);
    if (
      Object.values(event.target.files) &&
      Object.values(event.target.files).length > 0
    ) {
      if (
        !(
          Object.values(event.target.files)
            ?.map((file) => file?.size)
            .reduce((a, b) => a + b, 0) >
          25 * 1024 * 1024
        )
      ) {
        setSelectedFiles((prev) =>
          prev.concat(Object.values(event.target.files)),
        );
        // setInvalidFile(false);
      } else {
        setSelectedFiles((prev) =>
          prev.concat(Object.values(event.target.files)),
        );
        // inputFile.current.value = null;
        // setInvalidFile(
        //   'The files you are trying to upload is larger than the 25 MB of total limit.',
        // );
      }
    } else {
      // inputFile.current.value = null;
    }
  };

  const handleAddMoreAttachments = () => {
    setFileUploading(true);
    if (selectedFiles && selectedFiles?.length > 0) {
      selectedFiles?.forEach((selectedFile) => {
        console.log(selectedFile);
        dispatch(
          getUploadUrlForFile(
            {
              fileName: selectedFile.name,
              format: selectedFile.type,
              purpose: 'admin_document_template_exp',
              size: selectedFile.size,
              type: 'pdf',
              indexHost: pineconeIndices?.find(
                (indice) => indice?.name === ragIndexName,
              )?.host,
              indexName: ragIndexName,
              namespace,
            },
            ({ fileId, url }) => {
              dispatch(
                uploadAudio(url, selectedFile, () => {
                  console.log('file uploaded');
                  dispatch(
                    confirmFileUpload(fileId, () => {
                      setFileUploading(false);
                      setShowValuePropFileUploadDialog(false);
                      setSelectedFiles([]);
                      setRagIndexName(
                        process.env.REACT_APP_TARGET_ENV === 'local' ||
                          process.env.REACT_APP_TARGET_ENV === 'development'
                          ? 'dev-doc-template-exp-v1'
                          : 'prod-doc-template-exp-v1',
                      );
                      setNamespace('');
                      dispatch(
                        getUploadedFiles((files) => {
                          setValuePropFiles(files);
                        }),
                      );
                    }),
                  );
                }),
              );
            },
          ),
        );
      });
    }
  };

  useEffect(() => {
    if (showValuePropFileUploadDialog) {
      dispatch(
        getDocumentNamespaces((namespaces) => {
          setDocumentNamespaces(namespaces);
        }),
      );
    }
  }, [showValuePropFileUploadDialog]);

  useEffect(() => {
    dispatch(
      getUploadedFiles((files) => {
        setValuePropFiles(files);
      }),
    );
    dispatch(
      getPineconeIndices((indices) => {
        setPineconeIndices(
          indices?.filter((indice) =>
            indice?.name?.includes(
              process.env.REACT_APP_TARGET_ENV === 'local' ||
                process.env.REACT_APP_TARGET_ENV === 'development'
                ? 'dev-doc'
                : 'prod-doc',
            ),
          ) || [],
        );
        setRagIndexName(
          process.env.REACT_APP_TARGET_ENV === 'local' ||
            process.env.REACT_APP_TARGET_ENV === 'development'
            ? 'dev-doc-template-exp-v1'
            : 'prod-doc-template-exp-v1',
        );
      }),
    );
  }, []);

  return (
    <Fixed>
      <Box
        width={{ xs: '100vw', sm: '100vw', md: 'calc(100vw - 266px)' }}
        height={{
          xs: 'calc(100vh - 60px)',
          sm: 'calc(100vh - 70px)',
          md: 'calc(100vh - 80px)',
        }}
        sx={{
          overflow: 'hidden',
        }}
        display={'flex'}
        flexDirection={{ xs: 'column', md: 'column' }}
        position={'relative'}
        gap={1}
      >
        <Box
          display={'flex'}
          flexDirection={{ xs: 'column', sm: 'column', md: 'row' }}
          padding={2}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              border: '1px solid #d3d3d3',
              borderRadius: 2,
              padding: 2,
              width: 1,
              height: 1,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Typography color={'text.secondary'}>Rag Documents</Typography>
              <Tooltip arrow placement="top" title="Add more">
                <AddCircle
                  sx={{
                    color: '#a3a3a3',
                    fontSize: 20,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setShowValuePropFileUploadDialog(true);
                  }}
                />
              </Tooltip>
            </Box>
            {valuePropFiles && valuePropFiles?.length > 0 ? (
              <>
                {valuePropFiles?.map((file) => (
                  <Box
                    key={file?.id}
                    sx={{
                      display: 'flex',
                      alignItems: 'stretch',
                      gap: 1,
                      border: '1px solid #d3d3d3',
                      borderRadius: 2,
                      padding: 1,
                      width: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        flex: 1,
                      }}
                    >
                      <Description
                        sx={{
                          fontSize: 50,
                          color: theme.palette.text.secondary,
                        }}
                      />
                      {valuePropFileTitleEditMode?.id === file?.id ? (
                        <TextField
                          label="File Title"
                          variant="outlined"
                          name={'fileTitle'}
                          size="small"
                          fullWidth
                          value={valuePropFileTitle}
                          onChange={(e) =>
                            setValuePropFileTitle(e.target.value)
                          }
                        />
                      ) : (
                        // <Tooltip
                        //   arrow
                        //   placement="top"
                        //   title={
                        //     file?.summary ||
                        //     file?.fileTitle ||
                        //     file?.fileName ||
                        //     ''
                        //   }
                        // >
                        <span>
                          <Typography
                            variant="body2"
                            color={'text.secondary'}
                            sx={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: '1',
                              WebkitBoxOrient: 'vertical',
                              maxWidth: '100%',
                            }}
                          >
                            {file?.fileTitle ||
                              file?.fileName ||
                              'No filename specified'}
                          </Typography>
                          {file?.fileTitle ? (
                            <Typography
                              variant="caption"
                              color={'text.secondary'}
                              sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: '1',
                                WebkitBoxOrient: 'vertical',
                                maxWidth: '100%',
                              }}
                            >
                              {file?.fileName || 'No filename specified'}
                            </Typography>
                          ) : null}
                          <Box sx={{ display: 'flex', gap: 1, marginTop: 1 }}>
                            <Chip
                              label={
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                  }}
                                >
                                  <Typography
                                    variant="caption"
                                    // color={'text.secondary'}
                                  >
                                    {file?.namespace}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    // color={'text.secondary'}
                                  >
                                    |
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    color={'text.secondary'}
                                  >
                                    namespace
                                  </Typography>
                                </Box>
                              }
                              size="small"
                              variant="outlined"
                              // sx={{
                              //   ml: 1,
                              // }}
                            />
                            <Chip
                              label={
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                  }}
                                >
                                  <Typography
                                    variant="caption"
                                    // color={'text.secondary'}
                                  >
                                    {file?.indexName}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    // color={'text.secondary'}
                                  >
                                    |
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    color={'text.secondary'}
                                  >
                                    rag index
                                  </Typography>
                                </Box>
                              }
                              size="small"
                              variant="outlined"
                              // sx={{
                              //   ml: 1,
                              // }}
                            />
                          </Box>
                        </span>
                        // </Tooltip>
                      )}
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 2,
                        borderLeft: `1px solid ${theme.palette.divider}`,
                        paddingX: 2,
                      }}
                    >
                      {valuePropFileTitleEditMode?.id === file?.id ? (
                        <>
                          <Tooltip title="Cancel" arrow placement="top">
                            <IconButton
                              sx={{
                                width: 30,
                                height: 30,
                              }}
                              onClick={() => {
                                setValuePropFileTitleEditMode(null);
                              }}
                            >
                              <Close sx={{ fontSize: 24 }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Done" arrow placement="top">
                            <IconButton
                              sx={{
                                borderRadius: 1,
                                width: 30,
                                height: 30,
                              }}
                              disabled={updatingValuePropFileTitle}
                              onClick={() => {
                                setUpdatingValuePropFileTitle(true);
                                // dispatch(
                                //   updateValuePropFileTitle(
                                //     valuePropFileTitleEditMode?.id,
                                //     valuePropFileTitle,
                                //     () => {
                                //       setUpdatingValuePropFileTitle(
                                //         false,
                                //       );
                                //       dispatch(
                                //         getOrganizationConfigs(
                                //           (data) => {},
                                //         ),
                                //       );
                                //       setValuePropFileTitleEditMode(null);
                                //     },
                                //   ),
                                // );
                              }}
                            >
                              {updatingValuePropFileTitle ? (
                                <CircularProgress size={24} />
                              ) : (
                                <Check sx={{ fontSize: 24 }} />
                              )}
                            </IconButton>
                          </Tooltip>
                        </>
                      ) : (
                        <>
                          {/* <Tooltip
                            arrow
                            placement="top"
                            title="Edit File Title"
                          >
                            <EditOutlined
                              sx={{
                                fontSize: 24,
                                color: 'text.secondary',
                                cursor: 'pointer',
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setValuePropFileTitleEditMode(file);
                              }}
                            />
                          </Tooltip> */}
                          <Tooltip arrow placement="top" title="Download">
                            <CloudDownload
                              // fontSize={'small'}
                              sx={{
                                color: 'text.secondary',
                                cursor: 'pointer',
                              }}
                              onClick={() => {
                                window.open(file?.custom?.url, '__blank');
                              }}
                            />
                          </Tooltip>
                          <Tooltip arrow placement="top" title="Delete">
                            <DeleteOutline
                              // fontSize={'small'}
                              sx={{
                                color: 'text.secondary',
                                cursor: 'pointer',
                              }}
                              onClick={() => {
                                setShowConfirmDeleteValuePropFile(file);
                              }}
                            />
                          </Tooltip>
                        </>
                      )}
                    </Box>
                  </Box>
                ))}
              </>
            ) : (
              <Typography>None</Typography>
            )}
          </Box>
        </Box>
      </Box>
      <Modal
        open={Boolean(showValuePropFileUploadDialog)}
        onClose={(e, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown')
            setShowValuePropFileUploadDialog(false);
          else return;
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[5],
            // maxHeight: '30vh',
            maxWidth: '50vw',
            minWidth: '40vw',
            outline: 'none',
            borderRadius: 1,
            // padding: 3,
            position: 'relative',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              padding: 2,
            }}
          >
            <AutoCompleteMUI
              id="namespace"
              value={namespace}
              onChange={(event, newValue, reason) => {
                setNamespace(newValue || '');
                // console.log(reason);
              }}
              options={documentNamespaces}
              onTextChange={(e) => {
                if (e.target.value?.trim()) {
                  setNamespace(e.target.value);
                } else {
                  setNamespace('');
                }
              }}
              onKeyDown={() => {}}
            />
            <FormControl variant="outlined" sx={{ minWidth: 1 }} size="small">
              <FormLabel id="ragIndex">Pinecone Index</FormLabel>
              <Select
                labelId="ragindex-select-label"
                value={ragIndexName || ''}
                onChange={(e) => {
                  setRagIndexName(e.target.value);
                }}
              >
                {pineconeIndices && pineconeIndices.length > 0
                  ? pineconeIndices.map((indice) => (
                      <MenuItem value={indice?.name}>{indice.name}</MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <Typography color={'text.secondary'} variant="subtitle2">
              Include files as a reference for rag.
            </Typography>
            <InputLabel
              htmlFor="filePicker"
              sx={{ cursor: 'pointer', width: 1 }}
            >
              <input
                style={{ display: 'none' }}
                id="filePicker"
                ref={inputFile}
                type="file"
                multiple
                accept="application/pdf"
                onChange={(e) => {
                  onFileChange(e);
                }}
              />
              <Box
                sx={{
                  border: '1px dashed #d3d3d3',
                  borderRadius: 4,
                  width: 1,
                  minHeight: 120,
                  p: 2,
                  textAlign: 'center',
                }}
                display={'flex'}
                flexDirection={'column'}
                justifyContent={'center'}
                alignItems={'center'}
                gap={2}
              >
                {selectedFiles && selectedFiles?.length > 0
                  ? selectedFiles?.map((file, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'center',
                        }}
                      >
                        <Typography
                          color={'#677788'}
                          sx={{ whiteSpace: 'wrap' }}
                        >
                          {file?.name}
                        </Typography>
                        <Typography color={'text.secondary'}>
                          ({(file?.size / 1024 / 1024)?.toFixed(2)} MB)
                        </Typography>
                        <Tooltip title="Remove File" arrow>
                          <Close
                            sx={{
                              fontSize: 16,
                              color: '#677788',
                              border: '1px solid #677788',
                              borderRadius: '50%',
                              cursor: 'pointer',
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              setSelectedFiles((prev) =>
                                prev.filter((f, i) => i !== index),
                              );
                              inputFile.current.value = '';
                              setInvalidFile('');
                            }}
                          />
                        </Tooltip>
                      </Box>
                    ))
                  : null}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <Box
                    sx={{
                      background: theme.palette.primary.main,
                      borderRadius: 1,
                      padding: '4px 8px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                    }}
                  >
                    <Add
                      sx={{
                        color: '#fff',
                      }}
                    />
                    <Typography color={'#fff'}>Add Files</Typography>
                  </Box>
                  {selectedFiles && selectedFiles?.length > 0 ? (
                    <Box
                      sx={{
                        // background: theme.palette.primary.main,
                        borderRadius: 1,
                        padding: '4px 8px',
                        border: `1px solid ${theme.palette.primary.main}`,
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setSelectedFiles([]);
                        inputFile.current.value = '';
                        setInvalidFile('');
                      }}
                    >
                      <Typography>Remove Files</Typography>
                    </Box>
                  ) : null}
                </Box>
                <Box display={'flex'} flexDirection={'column'} gap={1}>
                  {invalidFile ? (
                    <Alert severity="error">
                      <Typography
                        variant="body1"
                        sx={{
                          whiteSpace: 'pre-wrap',
                          color: theme.palette.error.main,
                        }}
                      >
                        {invalidFile}
                      </Typography>
                    </Alert>
                  ) : null}
                  <Typography
                    variant="caption"
                    sx={{
                      whiteSpace: 'pre-wrap',
                    }}
                  >
                    (Only PDF file format is supported)
                  </Typography>
                  {/* <Typography
                    variant="caption"
                    sx={{
                      whiteSpace: 'pre-wrap',
                    }}
                  >
                    Upload files of total size not exceeding 25 MB
                  </Typography> */}
                </Box>
              </Box>
            </InputLabel>
          </Box>
          <Box
            width={1}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'space-between'}
            p={'8px 16px'}
            borderTop={'1px solid #d3d3d3'}
          >
            <Button
              size="small"
              variant="outlined"
              onClick={(e) => {
                setShowValuePropFileUploadDialog(null);
              }}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              size="small"
              startIcon={fileUploading ? <CircularProgress size={16} /> : null}
              disabled={
                !selectedFiles || selectedFiles?.length === 0 || fileUploading
              }
              onClick={(e) => {
                handleAddMoreAttachments();
              }}
              color="primary"
              // autoFocus
            >
              {fileUploading ? 'Uploading...' : 'Done'}
            </Button>
          </Box>
        </Box>
      </Modal>
      <Dialog
        open={Boolean(showConfirmDeleteValuePropFile)}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{
          zIndex: 10002,
          minWidth: 400,
          // '& .MuiPaper-root-MuiDialog-paper': {
          //   maxWidth: '70vw',
          // },
        }}
      >
        <DialogTitle id="alert-dialog-title">Confirm</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              minWidth: 400,
            }}
          >
            <Typography variant="body1">
              Are you sure you want to delete this value prop attatchment?
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box
            width={1}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'flex-end'}
          >
            <Button
              // data-trackid={'cta_permission_denied_dialog_close'}
              onClick={(e) => {
                setShowConfirmDeleteValuePropFile(null);
              }}
              color="primary"
              // autoFocus
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={deletingValuePropFile}
              startIcon={
                deletingValuePropFile ? <CircularProgress size={20} /> : null
              }
              onClick={(e) => {
                setDeletingValuePropFile(true);
                dispatch(
                  deleteRagDocuments(showConfirmDeleteValuePropFile?.id, () => {
                    setShowConfirmDeleteValuePropFile(null);
                    setDeletingValuePropFile(false);
                    dispatch(
                      getUploadedFiles((files) => {
                        setValuePropFiles(files);
                      }),
                    );
                  }),
                );
              }}
              color="primary"
              // autoFocus
            >
              Yes
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </Fixed>
  );
};

export default RagDocuments;
